import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';

import { LoginComponent } from './login.component';

@NgModule({
  declarations: [
    LoginComponent,
  ],

  imports: [
    CommonModule,
    FormsModule,
    ClarityModule,
  ],

  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],

})
export class LoginModule {
}



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts